import React, { useState, useEffect,useRef } from 'react';
import { Modal, Input, Button, message } from 'antd';
import ReactSelect from 'react-select';
import styled from 'styled-components';
import visitLogo from './VisitLogo1.svg'; // Add image source
import { createNewRequest, fetchDoctorVerticals } from '../../services/api/onboarding-requests';
import config from '../../../config';
import { connect } from 'react-redux';

const Img = styled.img`
  position: absolute; /* Enables absolute positioning */
  bottom: 0; /* Aligns the image to the bottom */
  left: 0; /* Aligns the image to the left */
  width: 243px; /* Set desired width */
  height: 317px; /* Maintain aspect ratio */
  margin: 10px; /* Optional: Adds some spacing from the edges */

`;



function CreateNewRequest({ agentName}) {
    
    const [visible, setVisible] = useState(true); 
    const [selectedSourceofRequest, setSelectedSourceofRequest] = useState(null); 
    const [doctorVerticals, setDoctorVerticals] = useState([]); 
    const [selectedDoctorVertical, setSelectedDoctorVertical] = useState('');
    const [centerName, setCenterName] = useState('');
    const [centerAddress, setCenterAddress] = useState('');
    const [centerContactNumber, setCenterContactNumber] = useState('');
    const [centerCity, setCenterCity] = useState('');
    const [centerState, setCenterState] = useState('');
    const [doctorName, setDoctorName] = useState('');
    const [doctorQualification, setDoctorQualification] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const inputRef = useRef(null);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [requestId, setRequestId] = useState(null);

    const apiKey = process.env.REACT_APP_GOOGLE_API;
    
    
    // Options for Select dropdowns
  const sourceofRequestOptions = [
    { value: 'ACM', label: 'ACM' },
    {value: 'Support', label: 'Support'},
    { value: 'Network Agent', label: 'Network Agent' },
  ];

useEffect(() => {
     console.log('useEffect triggered');
   getVerticals();
}, []);

const getVerticals = async () => {
    try {
        const response = await fetchDoctorVerticals();
        console.log('resp body:', response.body.verticals);
        if (response.body) {
            const verticals = response.body.verticals.map((vertical) => {
                return {
                    label: vertical.verticalName,
                    value: vertical.verticalId,
                };
            });
            console.log('Verticals:', verticals);
            
            setDoctorVerticals(verticals);
        } else {
            console.error('No data found in response');
        }
    } catch (error) {
        console.error('Error fetching verticals:', error);
    }
};

  const handleDoctorVertical = (selectedDoctorVertical) => {
    setSelectedDoctorVertical(selectedDoctorVertical); 
  };

  const handleSourceOfRequest = (source) => {
    setSelectedSourceofRequest(source); 
  };

  const handleCenterNameChange = (event) => {
    setCenterName(event.target.value);
  };

    const handleCenterContactNumberChange = (event) => {
    setCenterContactNumber(event.target.value);
    };

    const handleCenterCityChange = (event) => {
    setCenterCity(event.target.value);
    };

    const handleCenterStateChange = (event) => {
    setCenterState(event.target.value);
    };

    const handleDoctorNameChange = (event) => {
    setDoctorName(event.target.value);
    };
    const handleCenterAddressChange = (event) => {
    setCenterAddress(event.target.value);
    };

    const handleDoctorQualificationChange = (event) => {
    setDoctorQualification(event.target.value);
    };


    const handleSubmit = (event) => {
          event.preventDefault(); // Prevent default form submission behavior

        if (!centerCity.trim() || !centerState.trim()) {
          message.error('City and State are mandatory.');
          return;
        }

        const result = {
                        agentName: agentName,
                        source: selectedSourceofRequest ? selectedSourceofRequest.value : null,
                        center: centerName,
                        location: centerAddress,
                        city: centerCity,
                        state: centerState,
                        centerContactNumber: centerContactNumber,
                        doctorName: doctorName,
                        doctorQualification: doctorQualification,
                        doctorVertical: selectedDoctorVertical.value,
                        doctorLat:latitude,
                        doctorLng:longitude
                    };
                    console.log('Result:', result);

  createNewRequest(result)
  .then((response) => {
    setRequestId(response.body.requestId);
    console.log('Response:', response);
    if(response.body.message === 'success'){
      return 'success';
    }
    return '';
  }).then((response)=>{
    if(response === 'success')
    setSuccessModalVisible(true);
  })


    };

     
  useEffect(() => {
    const initAutocomplete = () => {
      const google = window.google;
      if (google && google.maps && google.maps.places) {
        const autocompleteInstance = new google.maps.places.Autocomplete(inputRef.current.input, {
        //   types: ['geocode'],
          componentRestrictions: { country: 'IN' }, // Restrict to India
        });

        // Add event listener for place selection
        autocompleteInstance.addListener('place_changed', () => {
          const place = autocompleteInstance.getPlace();
          if (place.geometry) {
    setLatitude(place.geometry.location.lat());
    setLongitude(place.geometry.location.lng());
     const address = place.formatted_address; 
            setCenterAddress(address);
  } else {
    console.log('No details available for the selected place.');
  }
        });

        setAutocomplete(autocompleteInstance);
      }
    };

    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
        script.async = true;
        script.onload = () => {
          initAutocomplete();
        };
        document.head.appendChild(script);
      } else {
        initAutocomplete();
      }
    };

    loadGoogleMapsScript();
  }, []);

  return (
    <div
      style={{
        backgroundColor: 'rgba(207, 200, 255, 0.3)',
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Modal
      centered
        title="Raise Empanelment Request"
        visible={visible}
        footer={null}
        width={666}
        mask={false}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px' }}>
          <div style={{ flex: '1', marginRight: '10px', paddingBottom: '8px' }}>
            <label><strong>Source of Request</strong></label>
            <ReactSelect
              value={selectedSourceofRequest}
              onChange={(e)=>handleSourceOfRequest(e)}
              options={sourceofRequestOptions}
              id={'selectSourceofRequest'}
              placeholder="Select Source of Request"
            />
          </div>
        </div>
     { 
     <DetailsSection title="Center Details">
  {/* <div style={{ flex: '1', marginBottom: '10px' }}> */}
    <label style={{ marginBottom: '5px' }}>Center Address</label>
    <Input
      ref={inputRef}  
      placeholder="Enter a location in India"
      style={{ flex: 1 }}
      value={centerAddress}
      onChange={handleCenterAddressChange}
    />
                        <div style={{ display: 'flex', gap: '10px'}}>
                <div style={{ flex: '1', marginBottom: '10px' }}>
                 <InputLabelWithInput 
                 type = 'text'
                            label="Center Name" 
                            placeholder="Enter Center Name" 
                            value={centerName} 
                            onChange={handleCenterNameChange} 
                        />
                        </div>
                {/* <label>Center Contact Number</label> */}

                <InputLabelWithInput
                label = 'Center Contact Number'
                type="tel"
                maxLength = '10'
                pattern="\d{10}"
                placeholder="Enter Center Contact Number"
                value={centerContactNumber}
                onChange={handleCenterContactNumberChange}/>

            </div>
            <div style={{ display: 'flex', gap: '10px'}}>
                <InputLabelWithInput
                label="City"
                type="text"
                placeholder="Enter City"
                value={centerCity}
                onChange={handleCenterCityChange}/>

                <InputLabelWithInput
                label="State"
                type="text"
                placeholder="Enter State"
                value={centerState}
                onChange={handleCenterStateChange}/>
            </div>
        </DetailsSection>
        
        
        }
        <DetailsSection title="Doctor Details">
          <InputLabelWithInput label="Doctor Name" type = 'text' placeholder="Enter Doctor Name"   value={doctorName}
                onChange={handleDoctorNameChange}/>
          <div style={{ display: 'flex', gap: '10px' }}>
            {/* <InputLabelWithInput label="Doctor Vertical" placeholder="Select Doctor Vertical" />
             */}
             <div style={{ flex: '1'}}>
             <label>Doctor Vertical</label>
              <ReactSelect
              value={selectedDoctorVertical}
              onChange={(e)=>handleDoctorVertical(e)}
              options={doctorVerticals}
              id={'selectDoctorVertical'}
              placeholder="Select Doctor Vertical"
            />
            </div>
            <InputLabelWithInput label="Qualification" type = 'text' placeholder="Enter Doctor Qualification" value={doctorQualification} onChange={(e)=> handleDoctorQualificationChange(e)}/>
          </div>
        </DetailsSection>

        <Button 
        type="primary"  
        style={{width: '634px',height: '34px',padding: '8px 24px',gap: '16px',borderRadius: '8px 8px 8px 8px',
        }}
        onClick={ handleSubmit}>
            Create Request
            </Button>
        
      </Modal>
      <Modal
          centered
          visible={successModalVisible}
          onCancel={() => setSuccessModalVisible(false)}
          footer={null}
          style={{
            textAlign: 'center',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
          bodyStyle={{
            padding: '20px',
          }}
        >
          <p
            style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#333',
              padding: '10px',
            }}
          >
            Request raised successfully with Request ID: {requestId} !
          </p>
        </Modal>

      <Img src={visitLogo} alt="Visit Logo" />
    </div>
  );
}

// Reusable component for labeled input
const InputLabelWithInput = ({ label, placeholder, value, onChange, type, maxLength, ref }) => (
  <div style={{ flex: '1', marginBottom: '10px' }}>
    <label>{label}</label>
    <Input
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value}          
      onChange={onChange}    
      type={type}            
      maxLength={maxLength}
      ref={ref}
    />
  </div>
);

// Reusable component for details section
const DetailsSection = ({ title, children }) => (
    <div>

    <label><strong>{title}</strong></label>
    <div style={{
        border: '1px solid #d9d9d9',
        borderRadius: '4px',
        padding: '10px',
        marginBottom: '10px',
        marginTop: '10px',
        width: '100%'
    }}>
    {children}
  </div>
        </div>
);

const mapStateToProps = (state) => ({
  agentName: state.user.name, 
});

export default connect(mapStateToProps)(CreateNewRequest);
